import { useQuery } from '@tanstack/react-query'

import type { GetActiveLoadingSlideResponse } from '../../types/loading-slide.js'

import { apiClient } from '../../lib/client.js'
import { loadingSlideKeys } from './keys.js'

export const useGetActiveLoadingSlideQuery = () => {
  return useQuery({
    queryFn: async () => {
      const response = await apiClient.client.get<GetActiveLoadingSlideResponse | null>(
        '/loading-slide/active'
      )
      return response.data
    },
    queryKey: loadingSlideKeys.active,
  })
}
